import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchStocktakeDetail(id) {
  const { data: raw } = await request.get(`/ims/stocktake/${id}`);
  return parseVer4DetailResponse(raw);
}
